import { handleResponse, handleData } from './responses'
import { getToken } from 'utils/misc'

const api = {
    /**
     * Fetch with method: GET
     * @param {*} url The url to fetch
     * @param {*} options Options object
     * @returns
     */
    get: async url => {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })

        return response.json()
    },

    /**
     * Fetch with method: POST
     * @param {string} url
     * @param {object} options
     * @param {boolean} reloadWindow
     */
    post: async (url, data = {}, reloadWindow = false) => {
        const token = getToken()
        let body = new FormData()

        if (data && !(data instanceof FormData))
            Object.entries(data).forEach(entry => body.set(entry[0], entry[1]))

        // Replace body with data if data already is of type FormData
        if (data instanceof FormData) {
            body = data
        }

        body.set('__RequestVerificationToken', token)

        const request = await fetch(url, {
            method: 'POST',
            body,
        })

        const response = await handleResponse(request, url)
        const nextData = await handleData(response)

        // if (reloadWindow === true) {
        //     window.location.reload();
        //     return; 
        // }

        return nextData
    },
}

export default api
